<!--<ngx-spinner bdOpacity=0.9 bdColor="rgba(164,39,39,0)" size="default" color="#ec1919" type="line-spin-clockwise-fade-rotating">
  <h1>Loading</h1>
</ngx-spinner>-->

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#ff0000" type="ball-scale-ripple-multiple" [fullScreen]="true">
  <h1 style="color: white"> Loading... </h1>
</ngx-spinner>
